// extracted by mini-css-extract-plugin
module.exports = {"addButton":"Templates_addButton__1QwKL","container":"Templates_container__yCW1C"};